"use client";

// npm packages
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../Button";
import Text from "../Text";
import {
    reset,
} from "@/redux/reducers/auth-reducer";
import { EMAIL, PHONE } from "@/constants";

const TryAnotherMethod = ({ activeTab, setActiveTab, }) => {
    const dispatch = useDispatch();
    const { isNumberOfAttemptExceeded } = useSelector((state) => state.auth);
    
    const handleTryAnotherMethod = () => {
            dispatch(reset());
            setActiveTab(activeTab === PHONE ? EMAIL : PHONE);
        };
    
  return (
    <>
          {isNumberOfAttemptExceeded ? (
            <Button
                type="primary"
                className="min-w-[80px] py-12 px-10 rounded-[100px] gap-2 !text-16 w-full font-semibold !bg-tealgreen !text-white my-20"
                onClick={() => handleTryAnotherMethod()}
            >
                <Text
                    type="span"
                    className="text-16 text-inherit !font-bold font-encode-sans leading-20 tracking-[0.32px]"
                >
                    Try another log in method
                </Text>
            </Button>
          ) : null}
    </>
  )
}

export default TryAnotherMethod;
